import { getProcedureResult } from 'iguazu-rpc';
import { TYPE_CREDO_OPT_IN } from '../constants';
import { getPublicGuid, getAccountToken } from '../selectors';
import { makeReadMemberPreferencesArgs } from '../utils';
const getCredoPreferences = (state, types, timeout) => {
  const credoPreferences = [{
    type: TYPE_CREDO_OPT_IN,
    value: false
  }];
  const publicGuid = getPublicGuid(state);
  const accountToken = getAccountToken(state);
  const response = getProcedureResult({
    procedureName: 'readMemberPreferencesV1',
    args: makeReadMemberPreferencesArgs({
      publicGuid,
      accountToken,
      types,
      timeout
    })
  })(state);
  if (response instanceof Error) {
    return {
      ...credoPreferences,
      error: response
    };
  }
  return response || {};
};
export default getCredoPreferences;